import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class LeadPipelineFilterOptionsResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                commercial_channels: ['Horeca', 'Retail', 'Cadenas'],
                spans_several_commercial_channels: true,
                shows_responsible_filter: true,
                responsibles: [
                    {email: 'closer@saporedipane.com', name: 'Jim Halpert'},
                    {email: 'horeca-head@saporedipane.com', name: 'Dwight Schrute'},
                ],
                how_they_knew_us_names: ['Meta', 'TikTok', 'Google', 'LinkedIn', 'Referido', 'Ploteo de camiones',
                    'Feria - Trade Show', 'EAS', 'Otros'],
            },
            errors: [],
        };
    }

    commercialChannels() {
        return this.content().commercial_channels;
    }

    spansSeveralCommercialChannels() {
        return this.content().spans_several_commercial_channels;
    }

    showsResponsibleFilter() {
        return this.content().shows_responsible_filter;
    }

    responsibles() {
        return this.content().responsibles;
    }

    howTheyKnewUsNames() {
        return this.content().how_they_knew_us_names;
    }
}
